import { ISidenavMenuItem } from './sidenav-menu-item.interface';
import { SidenavMenuDivider } from './sidenav-menu-divider.model';
import { SidenavMenuItem } from './sidenav-menu-item.model';

/**
 * A sidenav configuration class
 */
export class SidenavConfig {
  /** The sidenav's menus items */
  public menuItems: ISidenavMenuItem[] = [];

  /**
   * Add a divider
   */
  public addDivider() {
    const divider = new SidenavMenuDivider();
    this.menuItems.push(divider);
  }

  /**
   * Add a menu item to the sidenav configuration
   * @param label - The menu item's label
   * @param route - The menu item's route
   */
  public addMenuItem(label: string, route: string) {
    const menuItem = new SidenavMenuItem(label, route);
    this.menuItems.push(menuItem);
  }
}
